import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { logout } from "../apis/helper";
import { IconButton } from "../inJoy-components/Button/IconButton";
import { FloatingPromoBar } from "../inJoy-components/FloatingPromoBar/FloatingPromoBar";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { hidePromoBar as hidePromoBarAction } from "../redux/ui/ui-slice";

interface MainLayoutProps {
	children: React.ReactNode;
	showHeader?: boolean;
	hidePromoBar?: boolean;
}

export const MainLayout = ({
	children,
	showHeader = true,
	hidePromoBar = true,
}: MainLayoutProps) => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const showPromoBar = useAppSelector((state) => state.ui.showPromoBar);

	const handleLogout = async () => {
		try {
			await logout();
		} catch (err) {
			// Continue with redirect even if logout API fails
			console.error("Logout error:", err);
		}
		navigate("/login");
	};

	return (
		<React.Fragment>
			<div className="w-full p-[0] m-[0]">
				{showHeader && (
					<div className="sticky top-[0] left-[0] z-50 w-full px-2.5 py-4 bg-white shadow-sm">
						<div className="relative max-w-[1400px] mx-auto flex justify-between items-center">
							<Link to="/" className="text-blue-600 hover:text-blue-800">
								<img
									src={`${import.meta.env.VITE_APP_WEBSITE_URL}/img/logo_word_color.svg`}
									alt="injoy logo"
								/>
							</Link>
							<div className="flex items-center gap-4">
								<IconButton
									icon="user_fill"
									type="Tertiary"
									size="Small"
									onClick={handleLogout}
								/>
							</div>
						</div>
					</div>
				)}
				{children}
			</div>
			{showPromoBar && !hidePromoBar && (
				<FloatingPromoBar
					className="bottom-5"
					onButtonClick={() =>
						window.open("https://injoy.neuinx.com/", "_blank")
					}
					onClose={() => dispatch(hidePromoBarAction())}
				/>
			)}
		</React.Fragment>
	);
};
